import { ISuite } from 'src/components/SharedTypes';

const filterValidSelectedSuiteIds = (
  suites: ISuite[],
  initialSelectedSuiteIds: string[]
): string[] => {
  const validSelectedSuiteIds: string[] = [];

  for (const selectedSuiteId of initialSelectedSuiteIds) {
    const selectedSuite: ISuite = suites.find(
      (suite: ISuite) => suite.id === selectedSuiteId
    );
    const isSuiteStillEligible: boolean = selectedSuite?.isKeyHandOff === true;

    if (isSuiteStillEligible) {
      validSelectedSuiteIds.push(selectedSuiteId);
    }
  }

  return validSelectedSuiteIds;
};

const filterUpdatedSelectedSuiteIds = (
  suiteId: string,
  selectedSuiteIds: string[]
): string[] => {
  const isSuiteCurrentlySelected: boolean = selectedSuiteIds.includes(suiteId);
  let updatedSelectedSuiteIds: string[];

  if (isSuiteCurrentlySelected) {
    updatedSelectedSuiteIds = selectedSuiteIds.filter(
      (id: string) => id !== suiteId
    );
  } else {
    updatedSelectedSuiteIds = [...selectedSuiteIds, suiteId];
  }

  return updatedSelectedSuiteIds;
};

export { filterValidSelectedSuiteIds, filterUpdatedSelectedSuiteIds };
